import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactForm from '../components/contactForm/ContactForm';
import ContactDetails from '../components/contactDetails/ContactDetails';
import PageSEO from '../components/PageSEO';

const Contact = () => {
  const { t } = useTranslation('contacts');

  return (
    <section className="contact-section section" id="contactForm">
      <PageSEO
        title={`${t('title')} | PixelCraft`}
        description={t('seo.description')}
        path="/contacts"
      />
      <div className="container">
        <div className="contact-section__intro">
          <h1 className="title-1">{t('title')}</h1>
          <h2 className="subtitle">{t('subtitle')}</h2>
        </div>
        <div className="contact-section__grid">
          <ContactDetails />
          <div className="contact-card contact-card--form">
            <h2 className="contact-card__title">{t('form.title')}</h2>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
